
import { useEffect, useState } from 'react';

export const useUserSession = () => {
  const [user, setUser] = useState<any | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [jwtToken, setJwtToken] = useState<any>(null)
  useEffect(() => {
    const raw = localStorage.getItem('auth_token');
    if (raw) {
      console.log("Raw ::: ", raw)
      try {
        setUser(JSON.parse(raw));
        setJwtToken(JSON.parse(raw))
      } catch {
        localStorage.removeItem('auth_token');
      }
    }
    setIsLoaded(true);
  }, []);

  // Rename isLoaded to isLoading for consistency with AuthPage.tsx
  const isLoading = !isLoaded;

  return { user, isLoading, isLoaded,jwtToken };
};
